const SpanCollor = ({ color, children }) => {
    const colors = {
        purple: '#C084F6',
        green: '#4ADE80',
        pink: '#ff0066',
        yellow: '#EAB308',
        silver: '#19191A',
        blue: '#0099ff'
    };

    return <span style={{ color: colors[color] || "inherit" }}>{children}</span>;
}

export default SpanCollor; 